var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"photo-wrapper d-flex p-0",on:{"click":function($event){_vm.$emit('click')}}},[(_vm.show)?_c('p',{staticClass:"m-0"},[_c('img',{attrs:{"src":_vm.src}})]):_c('i',{staticClass:"far fa-image mt-3 mb-3"})])}
var staticRenderFns = []

export { render, staticRenderFns }